import { useBrandStore, useIntegrationsStore } from 'stores';
import type { Integration } from 'types/integrations';
import useHandleApi from './useHandleApi';
import useProximaSDK from './useProximaSDK';

export default function useIntegrationApi() {
  const { loading, handleApi } = useHandleApi({
    apiDomain: import.meta.env.VITE_PROXIMA_INTEGRATIONS_API_URL
  });
  const integrationsApi = useProximaSDK('IntegrationsApi');
  const integrationStore = useIntegrationsStore();
  const { brand } = useBrandStore();

  const getIntegrationBatch = async (brandIds: string) => {
    const endpoint = `/integration/batch/history?brandId=${brandIds}`;
    return handleApi({ endpoint });
  };

  const getIntegrations = async (brandId: string) =>
    handleApi({ endpoint: `/brand/${brandId}/integration` });

  const fetchIntegrationsHistory = async () => {
    integrationStore.clear();

    const { brandId } = brand;

    const response = await integrationsApi.getIntegrationsHistory({ brandId });

    if (response.status !== 200) return;

    const integrations = response.data ?? [];

    // If we have integrations set them in the store
    integrationStore.addIntegration(integrations as Integration[]);
  };

  return {
    loading,
    fetchIntegrationsHistory,
    getIntegrationBatch,
    getIntegrations
  };
}
